/**
 * A form field the address book fills with an entry of one kind other than a party (#221): a place,
 * a plate, or a driver. A party block is `PartyField` (`partyFill.tsx`), whose choice fills a whole
 * block; these fill one field, or a driver's two.
 */

/** The kinds that fill one field with one value. */
export type ValueKind = 'PLACE' | 'VEHICLE' | 'TRAILER'

/** A field the book fills with one value: an address, or a plate. */
export interface ValueField {
  kind: ValueKind
  column: string
}

/**
 * The driver's DNI/NIE, and on a route sheet the name beside it. A goods DeCA has no column for the
 * name, so there `columns.name` is absent and a choice fills the DNI/NIE alone.
 */
export interface DriverField {
  kind: 'DRIVER'
  columns: { nif: string; name?: string }
  field: 'nif' | 'name'
}

export type BookField = ValueField | DriverField

/** The column a book field is, which `FormField` checks its own name against. */
export const columnOf = (book: BookField): string | undefined =>
  book.kind === 'DRIVER' ? book.columns[book.field] : book.column
